package org.tlsys.json

import org.tlsys.await
import kotlin.js.Promise

actual class AsyncResult<T : JDTO?>(val promise: Promise<T>) {
    suspend fun await(): T = promise.await()
    suspend fun await(timeout: Int): T = promise.await(timeout)
}